import {createAsyncThunk} from "@reduxjs/toolkit";
import api from "../servics/product/api";

export const addProductToWishlist =
    createAsyncThunk(
        "wishlist/add",
        async (payload) => {

            const response =
                await api.post(
                    "/wishlist",
                    payload
                );

            return response.data;
        }
    );